import httpService from "./http.service";

class PageBuilderService {
    getPageBuilderUrl = "/pageBuilders/admin";

    getPageBuilder = (query) => {
        return httpService.get(`/pageBuilders/admin?${query}`);
    };
    createPageBuilder = (model) => {
        return httpService.post("/pageBuilders", model, "createPageBuilder");
    };
    editPageBuilder = (id, model) => {
        return httpService.patch("/pageBuilders/" + id, model, "editPageBuilder", {}, "patch");
    };
    deletePageBuilder = (id) => {
        return httpService.delete("/pageBuilders/" + id);
    };
    seoPageBuilder = (id, model) => {
        return httpService.patch("/pageBuilders/seo/" + id, model, "seoPageBuilders");
    };
    faqPageBuilder = (id, model) => {
        return httpService.patch("/pageBuilders/faq/" + id, model, "faqPageBuilder", {}, "patch");
    };


    getPageBuilderRow = (pageId) => {
        return httpService.get(`/pageBuilders/admin/rows/${pageId}`);
    };
    createPageBuilderRow = (pageId, model) => {
        return httpService.form(`/pageBuilders/rows/${pageId}`, model, "createPageBuilder");
    };
    editPageBuilderRow = (pageId, id, model) => {
        return httpService.form(`/pageBuilders/rows/${pageId}/` + id, model, "editPageBuilder", {}, "patch");
    };
    deletePageBuilderRow = (pageId, id) => {
        return httpService.delete(`/pageBuilders/rows/${pageId}/` + id);
    };
}

const pageBuildersService = new PageBuilderService();
export default pageBuildersService;